import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core';
import { CardHeaderDetalleEnvioStyles } from '../../styles';


interface CardHeaderDetalleProp extends WithStyles<typeof CardHeaderDetalleEnvioStyles> {
    children?: React.ReactNode;
    className?: string;
}

const CardHeaderDetalleEnvioComponent = (props:CardHeaderDetalleProp) => {
    const classes = props.classes;
    return(
        <div className = {classes.header}>Detalle del envío</div>
    );

}

export const CardHeaderDetalleEnvio = withStyles(CardHeaderDetalleEnvioStyles)(CardHeaderDetalleEnvioComponent)